import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import type { AiModel } from '../types';

export function useAiModels(): {
  aiModels: AiModel[];
  isLoading: boolean;
  error: string | null;
} {
  const [aiModels, setAiModels] = useState<AiModel[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetch = async () => {
      setIsLoading(true);
      setError(null);
      const { data, error } = await supabase
        .from('ai_models')
        .select('id, name, enabled')
        .order('name');

      if (cancelled) return;

      if (error) {
        setError(error.message);
      } else {
        setAiModels(data ?? []);
      }
      setIsLoading(false);
    };

    fetch();
    return () => {
      cancelled = true;
    };
  }, []);

  return { aiModels, isLoading, error };
}
